// nodemodule imports
import React, {useState} from 'react';
import styled from "styled-components";

// project imports
import CopyInput from "../../reusable/CopyInput";


export default ({example, index}) => {
  const [clicked, toggleClicked] = useState(true);

  if (!example) return null;

  return (
    <Wrapper>
      {example.snippets.map(snippet => {
        const {title, content, type, copiable} = snippet;

        const copiableText = content.map(line => line.split("$").pop())
        return (
          <Snippet>
            <SnippetHead type={type}>
              <SnippetTitle type={type}>{title}</SnippetTitle>
              {
                copiable
                &&
                <CopyInput text={copiableText.join("\n")} clicked={clicked} toggleClicked={toggleClicked} iconColor={type === "code" ? "#FFFFFF": "#000000"} iconWidth={15} iconHeight={20}/>
              }
            </SnippetHead>
            <SnippetBody>
              {content.map((line, index) => {
                const prefix = line.split("$");
                return (
                  <Line>
                    {
                      (type === 'code' || type === 'response' )&&
                      <Number>{index + 1}</Number>
                    }
                    {
                      type === 'endpoint' &&
                      <Request>{prefix[0]}</Request>
                    }
                    <Code indent={parseInt(prefix[0])}>{prefix.pop()}</Code>
                  </Line>
                )
              })}
            </SnippetBody>
          </Snippet>
        )
      })}
    </Wrapper>

  )
}

const Wrapper = styled.div(props => ({
  margin: '24px 0 0 50px',
  maxWidth: 400,
  width: 400,
  "@media (max-width: 1280px)": {
    width: 360,
    margin: '24px 0 0 20px',
  },
  "@media (max-width: 1080px)": {
    width: 400,
    margin: '24px 0 0 0px',
  },
  "@media (max-width: 830px)": {
    width: "calc(100% - 40px)",
  },
}));

const Line = styled.div(props => ({
  display: 'flex',
}));

const Code = styled.div(props => ({
  fontFamily: 'Source Code Pro',
  marginLeft: 10 + props.indent,
  whiteSpace: 'nowrap'
}));

const Number = styled.div(props => ({
  fontFamily: 'Source Code Pro',
  position: 'sticky',
  left: 0,
  zIndex: 0,
  color:"rgba(255,255,255, 0.4)",
  background:"#15181C",
  paddingLeft:6,
  width:24,
  minWidth:24,
  userSelect:"none",
}));

const Request = styled.div(props => ({
  fontFamily: 'Source Code Pro',
  marginRight: 10
}));

const Snippet = styled.div(props => ({
  marginBottom: 24,
}));

const SnippetHead = styled.div(props => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '7px 20px 8px 16px',
  background: props.type === "code" ? '#23262A' : '#bababa'
}));

const SnippetTitle = styled.p(props => ({
  margin: 0,
  padding: 0,
  color: props.type === "code" ? '#FFFFFF' : '#000000',
  fontSize: 14,
  lineHeight: '21px'
}));

const SnippetBody = styled.div(props => ({
  background: '#15181C',
  fontSize: 14,
  lineHeight: '150%',
  padding: '24px 23px 24px 0px',
  color: '#FFFFFF',
  boxShadow: 'inset 0px 0px 30px rgba(0, 0, 0, 0.5)',
  overflow: 'auto',
}));
